<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oymycK/tc-custom/9781504083379.jpg?1726519015526" alt="This image is the cover for the book Cousin Phillis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cousin Phillis
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A rural young Englishwoman experiences her first love with a worldly engineer in this tale from the beloved author of <i>Cranford</i> and <i>Wives and Daughters</i>.</b></p><p> It is the 1840s in England, and the time has come for nineteen-year-old Paul Manning to make his own way in the world. He takes a position working for Edward Holdsworth, an engineer overseeing expansion of a railway line into the countryside. Paul’s work also takes him to Hope Farm and his relatives, the Holmans—his mother’s cousin, her minister husband, and their daughter, the tall and beautiful seventeen-year-old Phillis. Paul bonds with Holmans and soon brings his boss to the farm. A quasi-love triangle begins to blossom, and innocent Phillis’s world soon transforms . . . </p> Originally published in four parts in <i>The Cornhill Magazine</i> from1863 to 1864, <i>Cousin Phillis</i> is a Victorian novella that captures young people coming of age in a changing nation and a changing world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Gaskell
      </h2>
      
      <p class="authorDescription body article">Elizabeth Gaskell (1810&ndash;1865) was an English author and social activist best known for her novel <I>North and South</I>, a searing portrait of the industrial revolution and the tale of an unlikely romance between a beautiful and headstrong minister&rsquo;s daughter and a combative mill owner.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?095737f8